<template>
  <div class="greedy_bg">
    <div class="greedy_number">Current Round: {{ greedy_number }}</div>
    <div class="greedy_rules">
      <div>
        <van-button size="mini" color="#f48639" hairline class="greedy_rules_btn">rule</van-button>
      </div>
      <div>
        <van-button size="mini" color="#f48639" hairline class="greedy_rules_btn">规则</van-button>
      </div>
    </div>
    <div class="greedy_bg_div">
      <img src="./../assets/img/greedy_bg.png" style="height: 100%;">
      <!--      中间倒计时   -->
      <div class="greedy_gift_btn">
        <img src="./../assets/img/greedy_btn.png" style="height: 100%;">
      </div>
      <div class="greedy_gift_btn_times">{{ countdown }}</div>
      <!--      下注的金额   -->
      <div class="greedy_coin">
        <div class="greedy_coin_name">下注的金额</div>
        <div class="greedy_coin_type">
          <div class="greedy_coin_type_center" v-for="(c,i) in coin" :key="i">
            <div :class="coin_index === i ? 'greedy_coin_type_center_bg greedy_coin_type_checked' : 'greedy_coin_type_center_bg'" @click="coin_index = i">
              <div class="greedy_coin_type_center_bg_img"><img src="./../assets/img/greedy_coin.png" style="height: 100%;"></div>
              <div class="greedy_coin_type_center_bg_sum">{{ c.name }}</div>
            </div>
          </div>
        </div>
        <div class="greedy_coin_left" v-if="greedy_game_type.length > 0">
          <div class="greedy_coin_left_center" @click="choiceGiftType(0)">
            <img src="./../assets/img/greedy_type.png" class="greedy_type_center">
            <div class="greedy_gift_type_img"> <img :src="greedy_game_type[0].img" /></div>
            <div class="greedy_gift_number" v-if="greedy_game_type[0].number">{{ greedy_game_type[0].number }}</div>
            <div class="greedy_gift_type_coin">{{ greedy_game_type[0].times }} times</div>
          </div>
        </div>
        <div class="greedy_coin_right" v-if="greedy_game_type.length > 1">
          <div class="greedy_coin_left_center" @click="choiceGiftType(1)">
          <img src="./../assets/img/greedy_type.png" class="greedy_type_center">
          <div class="greedy_gift_type_img">  <img :src="greedy_game_type[1].img" /></div>
            <div class="greedy_gift_number" v-if="greedy_game_type[1].number">{{ greedy_game_type[1].number }}</div>
          <div class="greedy_gift_type_coin">{{ greedy_game_type[1].times }} times</div>
          </div>
        </div>
      </div>
      <!--  底部信息    -->
      <div class="greedy_bottom">
        <van-row>
          <van-col span="9" class="greedy_bottom_winning_style">
            <div class="greedy_bottom_winning_style_bg">
              <div class="greedy_bottom_winning"> Today`s Winning</div>
              <div class="greedy_bottom_winning_sum"> {{ today_winning }} </div>
            </div>
          </van-col>
          <van-col span="6" class="greedy_bottom_winning_style">
            <div class="greedy_bottom_winning_style_bg">
              <div class="greedy_bottom_winning_center"> my record</div>
            </div>
          </van-col>
          <van-col span="9" class="greedy_bottom_winning_style">
            <div class="greedy_bottom_winning_style_bg">
              <div class="greedy_bottom_winning">  Coins</div>
              <div class="greedy_bottom_winning_sum"> {{ diamonds }} </div>
            </div>
          </van-col>
          <van-col span="22" offset="1" class="greedy_slider">
            <van-slider v-model="sliderVal" bar-height="12px" button-size="0" active-color="#e7db28" inactive-color="#65053e"/>
            <div class="greedy_slider_div">
              <div class="greedy_slider_div_type" v-for="(r,i) in receive_coin" :key="i">
                <img src="./../assets/img/zuanshi.png" class="greedy_slider_div_type_img">
                <div class="greedy_slider_div_type_sum">{{ r.title }}</div>
              </div>
            </div>
          </van-col>
          <!--    下注结果      -->
          <van-col span="22" offset="1" class="greedy_result">
            <van-col span="5" class="greedy_result_name">Result</van-col>
            <van-col span="19" class="greedy_result_div">
              <div class="greedy_result_img" v-for="(r,i) in result_img" :key="i">
                <img :src="r.img">
              </div>
            </van-col>
          </van-col>
          <!--   今日排行第一的   -->
          <van-col span="22" offset="1" class="greedy_ranking" v-if="result_first">
            <van-col span="5" class="greedy_ranking_name">Today Ranking</van-col>
            <van-col span="6">
              <img :src="result_first.head_image"  class="greedy_ranking_userimg">
            </van-col>
            <van-col span="13" class="greedy_ranking_coin">
              <img src="./../assets/img/greedy_coin.png">
              {{ result_first.winning_coin }}
            </van-col>
          </van-col>
          <van-col span="10" offset="7" class="greedy_more"> 更多</van-col>
        </van-row>
      </div>
    </div>

    <div class="greedy_hei" v-if="turn"></div>
    <div
      v-for="(item,i) in gift"
      :key="i"
      :style="item.style"
      :class="8 - index === i + 1 ? 'greedy-prize-item greedy_gift_hide' : 'greedy-prize-item'"
    >
      <div :style="item.style_div" class="greedy_gift" @click="choiceGift(i)">
        <img src="./../assets/img/greedy_type.png" style="max-height: 100%;max-width: 100%;">
        <div class="greedy_gift_img"> <img :src="item.img" /></div>
        <div class="greedy_gift_number" v-if="item.number">{{ item.number }}</div>
        <div class="greedy_gift_coin">{{ item.times }} times</div>
      </div>
    </div>






    <div class="line_item" @click="goLottery()">
      立即挑选
    </div>

  </div>

</template>

<script>
  import '@/assets/css/style.css'
  import axios from "axios";
  import Toast from "vant/lib/toast"

  export default {
    data() {
      return {
        sliderVal: 60, // 进度条
        greedy_number: 1,
        countdown: 30, // 倒计时
        index: -1,    // 当前转动到哪个位置，起点位置
        count: 8,    // 总共有多少个位置
        timer: 0,    // 每次转动定时器
        speed: 50,   // 初始转动速度
        times: 0,    // 转动次数
        cycle: 30,   // 转动基本次数：即至少需要转动多少次再进入抽奖环节
        prizes: 3,   // 中奖位置
        prize: [0,1,2,3,4,5,6,7],   // 奖品位置
        gift:[],
        coin_index: 0,
        coin: [],
        receive_coin: [],
        result_img: [],
        turn: false,
        greedy_game_type: [],
        result_first: {},
        today_winning: 0,
        diamonds: 0,
        greedy_rule: '',
      }
    },
    created() {
      this.get_gift_list()
      this.get_userinfo()
    },
    methods: {
      choiceGiftType(i) {
        // 大分类下注
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=greedy&act=bet",{
          params : {
            token: token,
            bet_id: this.coin[this.coin_index].id,
            bet_gift_id: this.gift[i].id
          }
        }).then(res => {
          console.log("数据：", res)
          if (res.data.status == 1) {
            this.greedy_game_type[i].number = this.greedy_game_type[i].number + this.coin[this.coin_index].coin
            this.diamonds = res.data.data.diamonds
          }else{
            Toast(res.data.error)
          }
        }).catch((res) => {
          console.log("请求失败")
        })
      },
      choiceGift(i){
        // 选择 -- 小分类下注
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=greedy&act=bet",{
          params : {
            token: token,
            bet_id: this.coin[this.coin_index].id,
            bet_gift_id: this.gift[i].id
          }
        }).then(res => {
            console.log("数据：", res)
            if (res.data.status == 1) {
              this.gift[i].number = this.gift[i].number + this.coin[this.coin_index].coin
              this.diamonds = res.data.data.diamonds
            }else{
              Toast(res.data.error)
            }
        }).catch((res) => {
          console.log("请求失败")
        })

      },
      get_userinfo() {
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=greedy&act=get_userinfo&token="+token)
          .then(res => {
            console.log("数据：", res);
            if (res.data.status) {
              this.diamonds = res.data.data.diamonds
              this.today_winning = res.data.data.today_winning
              this.greedy_number = res.data.data.CurrentRound
              this.sliderVal = res.data.data.sliderVal
              this.receive_coin = res.data.data.greedy_task
              this.result_img = res.data.data.winning_resultn
              this.result_first = res.data.data.result_first
            }
          }).catch((res) => {
          console.log("请求失败");
        })
      },
      get_gift_list(){
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=greedy&act=get_index&token="+token)
          .then(res => {
            console.log("数据：", res);
            if (res.data.status) {
              this.gift = res.data.data.gift_list
              this.greedy_game_type = res.data.data.greedy_game_type
              this.coin = res.data.data.coin
              this.initPrizeList();
            }
          }).catch((res) => {
          console.log("请求失败");
        })
      },
      initPrizeList() {
        this.formatPrizeList(this.gift);
       console.log(this.gift)
      },
      // 格式化奖品列表，计算每个奖品的位置
      formatPrizeList (list) {
        // 记录每个奖的位置
        const angleList = []
        const l = list.length
        // 计算单个奖项所占的角度
        const average = 360 / l
        const half = average / 2
        // 循环计算给每个奖项添加style属性
        list.forEach((item, i) => {
          // 每个奖项旋转的位置为 当前 i * 平均值 + 平均值 / 2
          const angle = -((i * average) + half) - 23
          // 增加 style
          item.style = `-webkit-transform: rotate(${angle}deg);
                      transform: rotate(${angle}deg);`
          // 增加 style
          item.style_div = `-webkit-transform: rotate(${ - angle}deg);
                      transform: rotate(${ - angle}deg);`
          // 记录每个奖项的角度范围
          angleList.push((i * average) + half )
        })
        return list
      },
      goLottery() {
        //判断如果抽奖停止后才可以再次点击
        if(this.speed == 50) {
          const token = this.$route.query.token
          axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=greedy&act=luck_draw",{
            params : {
              token: token
            }
          }).then(res => {
              console.log("数据：", res);
              this.turn = true
              console.log(this.prizes)
              this.startRoll();
            }).catch((res) => {
            console.log("请求失败");
          })
        }
      },
      // 开始转动
      startRoll() {
        this.times += 1  // 转动次数
        this.oneRoll()  // 转动过程调用的每一次转动方法，这里是第一次调用初始化
        this.usePrize()
      },
      // 每一次转动
      oneRoll() {
        let index = this.index  // 当前转动到哪个位置
        console.log(index)
        const count = 8  // 总共有多少个位置
        index += 1
        if (index > count - 1) {
          index = 0
        }
        this.index = index
      },
      usePrize() {
        // 如果当前转动次数达到要求 && 目前转到的位置是中奖位置
        if (this.times > this.cycle + 10 && this.prizes === this.index) {
          clearTimeout(this.timer)   // 清除转动定时器，停止转动
          this.times = 0
          this.speed = 50    //速度初始化
          this.index = -1
          this.turn = false
        } else {
          if (this.times < this.cycle) {
            this.speed += 10   // 降低转动速度
          }
          this.timer = setTimeout(this.startRoll, this.speed)
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/greedy.vue